import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../assets/images/hero/hero-right.png'; // ✅ updated image
import img2 from '../../assets/images/icon/icon-01.png';
import img3 from '../../assets/images/layouts/avt-01.png';
import PurpleLine from '../../assets/images/icon/Line.png';

function Banner(props) {
    return (
        <section className="banner">
            <div className="shape right"></div>
            <div className="container big">
                <div className="row">
                    <div className="col-xl-6 col-md-12">
                        <div className="banner__left">
                            <div className="block-text">
                               <h2
  className="heading font-extrabold leading-snug relative z-10"
  style={{ fontSize: '85px', lineHeight: '1' }}
>
  Let Your{" "}
  <span className="relative inline-block align-baseline">
    <span className="relative z-10 inline-block">Money</span>
    <img
      src={PurpleLine}
      alt="Underline"
      style={{
        position: 'absolute',
        bottom: '-12px',
        left: '0',
        width: '100%',
        height: 'auto',
        pointerEvents: 'none',
      }}
    />
  </span>
  <br />
  Think
</h2>




<p
  className="desc text-gray-300 mt-5 font-medium"
  style={{ fontSize: '30px', lineHeight: '1.6' }}
>
  Plan like A Human. Trade Like A Machine
</p>


                                 <Link to="/pricing" className="action-btn">
  <span>Explore Plans</span>
</Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6 col-md-12">
                        <div className="banner__right">
                            <div className="image">
                                <img src={img1} alt="Smart Trading Visual" className="img-fluid" />
                            </div>

                            <div className="price">
                                <div className="icon">
                                    <img src={img2} alt="PipPlus Token" />
                                </div>
                                <div className="content">
                                    <p>Current Bid</p>
                                    <h5>2.26 ETH</h5>
                                </div>
                            </div>

                            <div className="owner">
                                <div className="image">
                                    <img src={img3} alt="User Avatar" />
                                </div>
                                <div className="content">
                                    <h5>PipPlusTech</h5>
                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Banner;
